import { render, staticRenderFns } from "./CoreDrawer.vue?vue&type=template&id=03630c18&scoped=true&"
import script from "./CoreDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreDrawer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreDrawer.vue?vue&type=style&index=0&id=03630c18&lang=scss&"
import style1 from "./CoreDrawer.vue?vue&type=style&index=1&id=03630c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03630c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03630c18')) {
      api.createRecord('03630c18', component.options)
    } else {
      api.reload('03630c18', component.options)
    }
    module.hot.accept("./CoreDrawer.vue?vue&type=template&id=03630c18&scoped=true&", function () {
      api.rerender('03630c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreDrawer/CoreDrawer.vue"
export default component.exports